import PropTypes from 'prop-types';
import './authlayout.scss';

export function ErrorLayout(props) {
  const { children } = props;

  return (
    <>
      <div>{children}</div>
    </>
  );
}

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired
};
